import { render } from "./AppContentButtonsComponent.vue?vue&type=template&id=51795a0a&scoped=true&ts=true"
import script from "./AppContentButtonsComponent.vue?vue&type=script&lang=ts"
export * from "./AppContentButtonsComponent.vue?vue&type=script&lang=ts"

import "./AppContentButtonsComponent.vue?vue&type=style&index=0&id=51795a0a&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51795a0a"]])

export default __exports__